import React from 'react';
import {Text, Container} from '@mantine/core';
import classes from './Footer.module.scss';


export const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className={classes.footer}>
            <Container ta="center">
                <Text>Ask an IFBB Pro Anything! Copyright © {currentYear}</Text>
            </Container>
        </footer>
    );
};
